import { Button, Flex, Heading, HStack, Input, Text } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { Field } from "@src/components/modules/auth/field";
import { AuthLayout } from "@src/components/modules/auth/layout";
import { LoadingOverlay } from "@src/components/ui-kit";
import { useStore } from "@src/utils/hooks";
import { getQueryParamOptional } from "@src/utils/routing";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { type FunctionComponent, useEffect } from "react";
import { AuthErrorMessage } from "./error-message";

export const TwoFALoginChallenge: FunctionComponent = observer(
  function TwoFALoginChallenge() {
    const router = useRouter();
    const {
      authStore: { twoFactorAuthenticationStore },
    } = useStore();

    useEffect(() => {
      if (router.isReady) {
        twoFactorAuthenticationStore.initChallengeStep(
          getQueryParamOptional("redirect_to", router.query),
        );
      }
    }, [router.isReady]);

    if (twoFactorAuthenticationStore.challengeStatus === "error") {
      return <AuthErrorMessage />;
    }

    return (
      <AuthLayout>
        <LoadingOverlay
          isLoading={twoFactorAuthenticationStore.challengeStatus === "loading"}
          position="absolute"
        >
          <Flex
            as="form"
            align="start"
            direction="column"
            gap="4"
            onSubmit={(event) => {
              event.preventDefault();
              twoFactorAuthenticationStore.challengeTwoFactorAuthentication();
            }}
          >
            <Heading as="h1" size="md">
              <Trans>Enter Two-Factor Authentication Code</Trans>
            </Heading>
            <Text>
              <Trans>
                Enter the two-factor authentication code that is displayed in
                the authenticator app on your device.
              </Trans>
            </Text>
            <Field
              isInvalid={
                twoFactorAuthenticationStore.challengeForm.code.hasError
              }
              errorMessage={
                twoFactorAuthenticationStore.challengeForm.code.error
              }
              label={t`Code`}
              input={
                <HStack>
                  <Input
                    w="auto"
                    autoComplete="one-time-code"
                    autoFocus
                    inputMode="numeric"
                    onChange={(event) =>
                      twoFactorAuthenticationStore.challengeForm.code.onChange(
                        event.target.value,
                      )
                    }
                    required
                    type="text"
                    value={
                      twoFactorAuthenticationStore.challengeForm.code.value
                    }
                  />
                  <Button
                    isLoading={
                      twoFactorAuthenticationStore.challengeStatus ===
                      "submitting"
                    }
                    type="submit"
                  >
                    <Trans>Continue</Trans>
                  </Button>
                </HStack>
              }
            />
            <Text>
              <Trans>
                In case you don't have access to your authentication code,
                please contact your administrator, managing director or CFO.
              </Trans>
            </Text>
          </Flex>
        </LoadingOverlay>
      </AuthLayout>
    );
  },
);
